export class CommunicationConstants {
    public static timeSlotsCol1 = [
        {
            id: 0,
            view: "00:00-01:00 AM",
            value: "0:00 AM-1:00 AM",
            startTime: "00:00",
            endTime: "01:00",
            checked: false
        },
        {
            id: 1,
            view: "01:00-02:00 AM",
            value: "1:00 AM-2:00 AM",
            startTime: "01:00",
            endTime: "02:00",
            checked: false
        },
        {
            id: 2,
            view: "02:00-03:00 AM",
            value: "2:00 AM-3:00 AM",
            startTime: "02:00",
            endTime: "03:00",
            checked: false
        },
        {
            id: 3,
            view: "03:00-04:00 AM",
            value: "3:00 AM-4:00 AM",
            startTime: "03:00",
            endTime: "04:00",
            checked: false
        },
        {
            id: 4,
            view: "04:00-05:00 AM",
            value: "4:00 AM-5:00 AM",
            startTime: "04:00",
            endTime: "05:00",
            checked: false
        },
        {
            id: 5,
            view: "05:00-06:00 AM",
            value: "5:00 AM-6:00 AM",
            startTime: "05:00",
            endTime: "06:00",
            checked: false
        },
        {
            id: 6,
            view: "06:00-07:00 AM",
            value: "6:00 AM-7:00 AM",
            startTime: "06:00",
            endTime: "07:00",
            checked: false
        },
        {
            id: 7,
            view: "07:00-08:00 AM",
            value: "7:00 AM-8:00 AM",
            startTime: "07:00",
            endTime: "08:00",
            checked: false
        },
        {
            id: 8,
            view: "08:00-09:00 AM",
            value: "8:00 AM-9:00 AM",
            startTime: "08:00",
            endTime: "09:00",
            checked: false
        },
        {
            id: 9,
            view: "09:00-10:00 AM",
            value: "9:00 AM-10:00 AM",
            startTime: "09:00",
            endTime: "10:00",
            checked: false
        },
        {
            id: 10,
            view: "10:00-11:00 AM",
            value: "10:00 AM-11:00 AM",
            startTime: "10:00",
            endTime: "11:00",
            checked: false
        },
        {
            id: 11,
            view: "11:00 AM-12:00 PM",
            value: "11:00 AM-12:00 PM",
            startTime: "11:00",
            endTime: "12:00",
            checked: false
        }
    ];
    public static timeSlotsCol2 = [
        {
            id: 12,
            view: "12:00 PM-1:00 PM",
            value: "12:00 PM-1:00 PM",
            startTime: "12:00",
            endTime: "13:00",
            checked: false
        },
        {
            id: 13,
            view: "1:00 PM-2:00 PM",
            value: "1:00 PM-2:00 PM",
            startTime: "13:00",
            endTime: "14:00",
            checked: false
        },
        {
            id: 14,
            view: "2:00 PM-3:00 PM",
            value: "2:00 PM-3:00 PM",
            startTime: "14:00",
            endTime: "15:00",
            checked: false
        },
        {
            id: 15,
            view: "3:00 PM-4:00 PM",
            value: "3:00 PM-4:00 PM",
            startTime: "15:00",
            endTime: "16:00",
            checked: false
        },
        {
            id: 16,
            view: "4:00 PM-5:00 PM",
            value: "4:00 PM-5:00 PM",
            startTime: "16:00",
            endTime: "17:00",
            checked: false
        },
        {
            id: 17,
            view: "5:00 PM-6:00 PM",
            value: "5:00 PM-6:00 PM",
            startTime: "17:00",
            endTime: "18:00",
            checked: false
        },
        {
            id: 18,
            view: "6:00 PM-7:00 PM",
            value: "6:00 PM-7:00 PM",
            startTime: "18:00",
            endTime: "19:00",
            checked: false
        },
        {
            id: 19,
            view: "7:00 PM-8:00 PM",
            value: "7:00 PM-8:00 PM",
            startTime: "19:00",
            endTime: "20:00",
            checked: false
        },
        {
            id: 20,
            view: "8:00 PM-9:00 PM",
            value: "8:00 PM-9:00 PM",
            startTime: "20:00",
            endTime: "21:00",
            checked: false
        },
        {
            id: 21,
            view: "9:00 PM-10:00 PM",
            value: "9:00 PM-10:00 PM",
            startTime: "21:00",
            endTime: "22:00",
            checked: false
        },
        {
            id: 22,
            view: "10:00 PM-11:00 PM",
            value: "10:00 PM-11:00 PM",
            startTime: "22:00",
            endTime: "23:00",
            checked: false
        },
        {
            id: 23,
            view: "11:00 PM-12:00 AM",
            value: "11:00 PM-12:00 AM",
            startTime: "23:00",
            endTime: "24:00",
            checked: false
        }
    ];
    public static communicationTypes = [
        {
            id: 1,
            name: "Messenger",
            checked: false
        },
        {
            id: 2,
            name: "Audio Calling",
            checked: false
        },
        {
            id: 3,
            name: "Video Calling",
            checked: false
        },
        {
            id: 4,
            name: "Email",
            checked: false
    }]
}